// Typelizer digest 740143c20c3deeda8e2904e4b84a9491
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /c/:company_id/account/setting/edit */
  edit: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/account/setting/edit', {}, options),
    method: 'get',
  }),

  /** GET /c/:company_id/account/setting */
  show: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/account/setting', {}, options),
    method: 'get',
  }),

  /** PATCH /c/:company_id/account/setting */
  update: (options?: RouteOptions): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/account/setting', {}, options),
    method: 'patch',
  }),
}
